import React from 'react'

import checkAccent from '../../assets/images/enterprise-ai/entry-path-check-accent.svg'
import checkWhite from '../../assets/images/enterprise-ai/entry-path-check-white.svg'
import { getEnterpriseAIContent } from '../../constants/enterpriseAIContent'

const EntryPathCheck = ({ featured }) => (
  <img
    className="enterprise-ai-entry-paths__check"
    src={featured ? checkWhite : checkAccent}
    alt=""
    width={24}
    height={24}
    loading="lazy"
    decoding="async"
    aria-hidden="true"
  />
)

const EnterpriseAIEntryPaths = ({ lang }) => {
  const { entryPaths } = getEnterpriseAIContent(lang)

  return (
    <section
      className="enterprise-ai-entry-paths"
      aria-labelledby="enterprise-ai-entry-paths-heading"
    >
      <div className="content container">
        <header className="enterprise-ai-entry-paths__head">
          <h2
            id="enterprise-ai-entry-paths-heading"
            className="enterprise-ai-entry-paths__heading"
          >
            {entryPaths.headingLines.map((line, index) => (
              <React.Fragment key={line}>
                {index > 0 && <br />}
                {line}
              </React.Fragment>
            ))}
          </h2>
          <div className="enterprise-ai-entry-paths__intro">
            <p className="enterprise-ai-entry-paths__intro-lead">
              {entryPaths.introLead}
            </p>
            <p className="enterprise-ai-entry-paths__intro-note">
              {entryPaths.introNote}
            </p>
          </div>
        </header>

        <div className="enterprise-ai-entry-paths__cards">
          {entryPaths.steps.map(step => {
            const featured = Boolean(step.featured)

            return (
              <article
                key={step.id}
                className={`enterprise-ai-entry-paths__card${
                  featured ? ' enterprise-ai-entry-paths__card--featured' : ''
                }`}
              >
                <div className="enterprise-ai-entry-paths__card-main">
                  <div className="enterprise-ai-entry-paths__card-head">
                    <span className="enterprise-ai-entry-paths__badge">
                      {step.badge}
                    </span>
                    <h3 className="enterprise-ai-entry-paths__card-title">
                      {step.title}
                    </h3>
                    <p className="enterprise-ai-entry-paths__card-description">
                      {step.description}
                    </p>
                  </div>

                  <dl className="enterprise-ai-entry-paths__stats">
                    {step.stats.map(stat => (
                      <div
                        key={stat.label}
                        className="enterprise-ai-entry-paths__stat"
                      >
                        <dt className="enterprise-ai-entry-paths__stat-label">
                          {stat.label}
                        </dt>
                        <dd className="enterprise-ai-entry-paths__stat-value">
                          {stat.value}
                        </dd>
                      </div>
                    ))}
                  </dl>

                  <ul className="enterprise-ai-entry-paths__features">
                    {step.features.map(feature => (
                      <li
                        key={feature}
                        className="enterprise-ai-entry-paths__feature"
                      >
                        {feature}
                      </li>
                    ))}
                  </ul>
                </div>

                <footer className="enterprise-ai-entry-paths__card-footer">
                  <EntryPathCheck featured={featured} />
                  <p className="enterprise-ai-entry-paths__footer-text">
                    {step.footer}
                  </p>
                </footer>
              </article>
            )
          })}
        </div>

        <p className="enterprise-ai-entry-paths__footnote">
          {entryPaths.footnote}
        </p>
      </div>
    </section>
  )
}

export default EnterpriseAIEntryPaths
